import React from "react";

import {
  ButtonField,
  CheckboxField, ContractSelectField, DateField,
  DatepickerField, DynamicSelectField, EgonAddressField, GoogleAddressField,
  InputField,
  RadiobuttonsField, RecaptchaField,
  SelectField, StateDrivenSelectInput, SuggestionInputField, SwitchRadioField,
  TextField,
  UploadField,
  UploadFieldGeneric,
  PasswordField, IbanField
} from "./FormFields";
import PlaceSearch from '../common/PlaceSearch/PlaceSearch.js'
import SearchWithSelectField from "./FormFields/SearchWithSelectField";
import ContractSelectWithRemoteOptionsField from "./FormFields/ContractSelectWithRemoteOptionsField";
import SelectSearchField from "./FormFields/SelectSearchField";

const getInterfaceTypes = otherProps => {
  return {
    // simple fields
    'input': <InputField {...otherProps} type={otherProps.inputType}/>,
    'radio': <RadiobuttonsField {...otherProps} />,
    'text': <TextField {...otherProps} />,
    'checkbox': <CheckboxField {...otherProps} />,
    'button': <ButtonField {...otherProps} />,
    'password': <PasswordField {...otherProps} />,

    // date-related fields
    'date': <DateField {...otherProps} />,
    'datepicker': <DatepickerField {...otherProps} />,

    // select fields
    'select': <SelectField {...otherProps} />,
    // used only for "Arera", to not apply for other cases
    'select-search': <SelectSearchField {...otherProps} />,
    'dynamic-select': <DynamicSelectField {...otherProps} />,
    'stateSelect': <StateDrivenSelectInput {...otherProps} />,
    'active-contract-select': <ContractSelectField {...otherProps} />,
    'searchWithSelect': <SearchWithSelectField {...otherProps} />,
    'selectWithRemoteOptions': <ContractSelectWithRemoteOptionsField {...otherProps} />,

    // other fields
    'captcha': <RecaptchaField {...otherProps} />,
    'file': <UploadField {...otherProps} />,
    's3File': <UploadFieldGeneric {...otherProps} />,
    'switch-radio': <SwitchRadioField {...otherProps} />,
    "google-address": <GoogleAddressField {...otherProps} />,
    "egon-address": <EgonAddressField {...otherProps} />,
    'google-address-fix': <PlaceSearch {...otherProps} />,
    'suggestions': <SuggestionInputField {...otherProps} />,
    'iban': <IbanField {...otherProps} />,
  }
};

export default getInterfaceTypes;
